/**
 * Import dependencies.
 */
import { h, Component } from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import '@material/textfield/mdc-textfield.scss';
import './index.scss';

/**
 * Create the component.
 */
export default class Checkbox extends Component {

constructor(props) {
		super(props);
		this.state = {
			focused: false,
		};
	}

	handleFocus = (e) => {
		this.setState({ focused: true });
		this.props.onFocus && this.props.onFocus(e);
	};

	handleBlur = (e) => {
		// TODO: find a way to match validity with custom provided helptext.
		this.setState({ focused: false });
		this.props.onBlur && this.props.onBlur(e);
	};

	handleChange = (e) => {
		this.props.onChange && this.props.onChange(e);
	};

	render({
		id,
		type,
		value,
		label,
		placeholder,
		disabled,
		dense,
		fullWidth,
		inputIcon = false,
		hasInputIcon,
		required,
		error,
		onFocus,
		onBlur,
		onChange,
		inputClassName,
		helpTextPersistent,
		...props
	}, {
		focused
	}, context) {

		const classes = classnames('mdc-textfield mdc-textfield--upgraded', {
			'mdc-textfield--dense': dense,
			'mdc-textfield--disabled': disabled,
			'mdc-textfield--focused': focused,
			'mdc-textfield--icon': inputIcon,
			'mdc-textfield--invalid': error
		}, { 'mdc-textfield--full': fullWidth });
		const wrapperClass = classnames('', { 'mdc-textfield--full': fullWidth });

		const classesLabel = classnames('mdc-textfield__label', {
			'mdc-textfield__label--float-above': focused || (value && value.length)
		});

		const classesHelptext = classnames('mdc-textfield-helptext', {
			'mdc-textfield-helptext--persistent': helpTextPersistent,
			'mdc-textfield-helptext--validation-msg': error
		});
		const idInternal = id ? id : `${new Date().getTime()}.${Math.floor(Math.random() * 100)}`;
		return (
			<div class={wrapperClass}>
				<label class={classes}>
					<input
						class={`mdc-textfield__input ${inputClassName||''}`}
						id={idInternal}
						type={type}
						value={value}
						placeholder={focused ? placeholder : false}
						disabled={disabled}
						required={required}
						aria-controls={`${idInternal}-validation-msg`}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.handleChange}
						{...props}
					/>
					<span class={classesLabel}>{label}</span>
					{inputIcon}
				</label>
				{!focused && <p id={`${idInternal}-validation-msg`} class={classesHelptext}>{error}</p>}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../q-mdc/quikr/core/text-field/index.js